// extracted by mini-css-extract-plugin
export default {"wrapper":"ImagePicker_wrapper__LR6D3","preview":"ImagePicker_preview__S-n+V","placeholder":"ImagePicker_placeholder__q8wtO","button":"ImagePicker_button__B+CL0"};